import { useFormikContext } from 'formik';
import { useEffect, useEffectEvent } from 'react';

import { CBC_CALC } from '@constants/formNames';
import { useBasketQuery } from '@hooks/useBasketQuery';

import { useCashbackCalculatorContext } from './CalculatorProvider/CalculatorContext';
import { type CalculatorFields } from './types';

const useLoadCbcCalculatorValues = () => {
  const { basketData } = useBasketQuery();
  const { setValues } = useFormikContext<CalculatorFields>();
  const { setUseCashbackValueInComms } = useCashbackCalculatorContext();

  const savedDetails = basketData?.cashbackCalculatorDetails;
  const hasSavedData = Boolean(savedDetails?.data);

  const load = useEffectEvent(() => {
    if (!savedDetails?.data) return;

    if (window.sessionStorage.getItem(CBC_CALC)) return;

    setValues(savedDetails.data as CalculatorFields);
    setUseCashbackValueInComms(savedDetails.useCashbackValueInComms);
  });

  useEffect(() => {
    if (hasSavedData) load();
  }, [hasSavedData]);
};

export { useLoadCbcCalculatorValues };
